import { render, staticRenderFns } from "./ClearFilters.vue?vue&type=template&id=1c354950&scoped=true"
import script from "./ClearFilters.vue?vue&type=script&lang=js"
export * from "./ClearFilters.vue?vue&type=script&lang=js"
import style0 from "./ClearFilters.vue?vue&type=style&index=0&id=1c354950&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c354950",
  null
  
)

export default component.exports